import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { changeVisualizationContext, getVisualizationContext } from './actions'
import RedirectPoints from './RedirectPoints'
import RedirectCash from './RedirectCash'
import MediaQuery from 'react-responsive'
import { getMenu } from 'Shared/GTM/getMenu'

import '@loyal_template/expandmenu.css'

class OnlyCash extends Component {
  state = { cash: false }
  state = { loaderCash: false }
  state = { loaderPoints: false }
  state = { onlyCash: this.props.onlyCash }

  componentDidMount () {
    if (this.props.catalogJustCash) {
      this.props.getVisualizationContext()
      this.props.onlyCash && this.setState({ cash: this.props.onlyCash })
    } else {
      this.setState({ cash: false })
    }
    this.setState({ changeContext: false })
  }

  componentDidUpdate () {
    if (this.state.cash !== this.props.onlyCash) {
      this.setCash(this.props.onlyCash)
    }
  }

  setCash = value => this.setState({ cash: this.props.onlyCash })
  openChangeContext = () => this.setState({ changeContext: !this.state.changeContext })

  handleChangeField = type => {
    if (type === 'cash') {
      this.setState({ cash: true })
      this.props.SetOnlyCash(true)
    } else {
      this.props.SetOnlyCash(false)
    }
    setTimeout(() => {
      window.location.href = '/'
    }, 1500)
  }

  render () {
    return (
      <Fragment>
        <MediaQuery minDeviceWidth={768}>
          <div className='toogle-value-points'>
            <input type='radio' name='visualization-context' id='context-cash' className='d-none' />
            <input type='radio' name='visualization-context' id='context-points' className='d-none' />

            {(this.state.cash) && <label className='toogle-menu'>
              <div className='row align-items-center'>
                <div className='toogle-icon col-auto'>
                  <i className='icon icon_cash icon-md' />
                </div>
                <div className='toogle-text col-auto'>
                  <button role='button' aria-controls='list-context' onClick={() => this.openChangeContext()} aria-expanded={this.state.changeContext}>
                    <strong>Compre com cartão</strong>
                  </button>
                </div>
                <div className='col-auto'>
                  <i className={`icon icon-ssm ${!this.state.changeContext ? 'icon_down color-brand-1' : 'icon_close'}`} />
                </div>
              </div>
            </label>}
            {(!this.state.cash) && <label className='toogle-menu'>
              <div className='row align-items-center'>
                <div className='toogle-icon col-auto'>
                  <i className='icon icon_gift icon-md' />
                </div>
                <div className='toogle-text col-auto'>
                  <button role='button' aria-controls='list-context' onClick={() => this.openChangeContext()} aria-expanded={this.state.changeContext}>
                    <strong>Resgate com pontos</strong>
                  </button>
                </div>
                <div className='col-auto'>
                  <i className={`icon icon-ssm ${!this.state.changeContext ? 'icon_down color-brand-1' : 'icon_close'}`} />
                </div>
              </div>
            </label>}
            {(this.state.changeContext) &&
            <ul id="list-context'" className='toogle-dropdown'>
              {(!this.state.cash) && <label className='toogle-menu' onClick={() => this.handleChangeField('cash')}>
                <div className='row align-items-center'>
                  <div className='toogle-icon col-auto'>
                    <i className='icon icon_cash icon-md' />
                  </div>
                  <div className='toogle-text col-auto'>
                    <button
                      role='button'
                      onClick={() => {
                        getMenu(this.props.profile, 'home', 'clique:resgate', 'compre-com-cartao')
                        this.handleChangeField('cash')
                      }}
                    >
                      Compre com Cartão
                    </button>
                  </div>
                </div>
              </label>}
              {(this.state.cash) && <label className='toogle-menu' onClick={() => this.handleChangeField('points')}>
                <div className='row align-items-center'>
                  <div className='toogle-icon col-auto'>
                    <i className='icon icon_gift icon-md' />
                  </div>
                  <div className='toogle-text col-auto'>
                    <button
                      role='button'
                      onClick={() => {
                        getMenu(this.props.profile, 'home', 'clique:resgate', 'compre-com-pontos')
                        this.handleChangeField('points')
                      }}
                    >
                      Resgate com pontos
                    </button>
                  </div>
                </div>
              </label>}
            </ul>
            }
          </div>
        </MediaQuery>
        <MediaQuery maxDeviceWidth={767}>
          <div
            className={`points-cash d-print-none ${
              this.props.isMobile ? 'zindex-default' : 'zindex-high'
            } ${
              this.props.isGuest && this.state.cash
                ? 'd-block'
                : !this.props.catalogJustCash
                  ? 'd-none'
                  : 'd-block'
            }`}
          >
            <div
              className={`loader-points-cash ${
                this.state.loaderCash ? 'd-block' : 'd-none'
              }`}
            >
              <RedirectCash />
            </div>
            <div
              className={`loader-points-cash ${
                this.state.loaderPoints ? 'd-block' : 'd-none'
              }`}
            >
              <RedirectPoints />
            </div>
            <div className='row mx-0 align-items-center h-100 main-menu d-none'>
              <ul className='col-12 radius-left overflow px-0'>
                <li
                  className={`col-12 py-half ${
                    this.state.cash
                      ? 'bg-featured border-featured'
                      : 'bg-white border-ui-4'
                  }`}
                >
                  <label
                    onClick={() => this.handleChangeField('cash')}
                    className={`d-block txt-center txt-subtitle ${
                      this.state.cash
                        ? 'color-ui-1 txt-circular-black'
                        : 'color-ui-2 txt-circular-black cursor'
                    }`}
                  >
                    <span className='nav-text'>PAGUE COM CARTÃO</span>
                    <i className='icon icon_cash' />
                  </label>
                </li>
                <li
                  className={`col-12 py-half ${
                    !this.state.cash
                      ? 'bg-featured border-featured'
                      : 'bg-white border-ui-4'
                  }`}
                >
                  <label
                    onClick={() => this.handleChangeField('points')}
                    className={`d-block txt-center txt-subtitle ${
                      !this.state.cash
                        ? 'color-ui-1 txt-circular-black'
                        : 'color-ui-2 txt-circular-black cursor'
                    }`}
                  >
                    <span className='nav-text'>TROQUE POR PONTOS</span>
                    <i className='icon icon_gift' />
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </MediaQuery>
      </Fragment>
    )
  }
}

OnlyCash.propTypes = {
  SetOnlyCash: PropTypes.func,
  catalogJustCash: PropTypes.bool,
  isGuest: PropTypes.bool,
  isMobile: PropTypes.bool,
  onlyCash: PropTypes.bool,
  getVisualizationContext: PropTypes.func,
  profile: PropTypes.object
}

const mapStateToProps = ({ catalog, onlyCash }) => ({
  catalogJustCash: catalog.onlyCash,
  onlyCash
})

const mapDispatchToProps = dispatch => ({
  SetOnlyCash: cash => dispatch(changeVisualizationContext(cash)),
  getVisualizationContext: () => dispatch(getVisualizationContext())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OnlyCash)



// WEBPACK FOOTER //
// ./src/App/MainMenu/OnlyCash/OnlyCash.js